import { callFunction } from "./functions-client";

// Network directory: browse/search profiles by type (public-safe fields).
export type TrustLevel = "unverified" | "id_verified" | "verified" | "authority_verified";

export interface DirectoryProfile {
  id: string;
  type: string;
  display_name: string | null;
  headline: string | null;
  image_url?: string | null;
  verified: boolean;
  trust_level?: TrustLevel;
  trust_label?: string;
  rating?: number | null;
  review_count?: number;
}

/** Badge tone per trust tier (shared by the directory + profile view). */
export const TRUST_TONE: Record<TrustLevel, string> = {
  unverified: "text-muted",
  id_verified: "text-verified",
  verified: "text-verified",
  authority_verified: "text-accent-strong",
};

export const DIRECTORY_TYPES: { key: string; label: string }[] = [
  { key: "", label: "All" },
  { key: "company", label: "Companies" },
  { key: "driver", label: "Drivers" },
  { key: "recruiter", label: "Recruiters" },
  { key: "broker_dispatcher", label: "Brokers" },
];

export const searchDirectory = (type?: string, q?: string) => {
  const p = new URLSearchParams();
  if (type) p.set("type", type);
  if (q) p.set("q", q);
  const qs = p.toString();
  return callFunction<{ profiles: DirectoryProfile[]; counts: Record<string, number> }>(
    `profiles/directory${qs ? `?${qs}` : ""}`,
    { method: "GET" },
  );
};
